const p = {
  "cdr-popup": "cdr-popup_15-6-1-beta-4",
  "cdr-popup--open": "cdr-popup--open_15-6-1-beta-4",
  "cdr-popup--closed": "cdr-popup--closed_15-6-1-beta-4",
  "cdr-popup__content": "cdr-popup__content_15-6-1-beta-4",
  "cdr-popup__arrow": "cdr-popup__arrow_15-6-1-beta-4",
  "cdr-popup--top": "cdr-popup--top_15-6-1-beta-4",
  "cdr-popup--bottom": "cdr-popup--bottom_15-6-1-beta-4",
  "cdr-popup--exit": "cdr-popup--exit_15-6-1-beta-4",
  "cdr-popup--corner-left": "cdr-popup--corner-left_15-6-1-beta-4",
  "cdr-popup--corner-right": "cdr-popup--corner-right_15-6-1-beta-4",
  "cdr-popup--left": "cdr-popup--left_15-6-1-beta-4",
  "cdr-popup--right": "cdr-popup--right_15-6-1-beta-4",
  "cdr-popup--corner-top": "cdr-popup--corner-top_15-6-1-beta-4",
  "cdr-popup--corner-bottom": "cdr-popup--corner-bottom_15-6-1-beta-4"
};
export {
  p as default
};
